import { GroupedTableErrorRowRenderProps } from "../types";

function GroupedTableErrorRow<TRow>({
    indentPx,
    message,
}: GroupedTableErrorRowRenderProps<TRow>): JSX.Element {
    return (
        <div className="GroupedTableErrorRow" style={{ paddingLeft: indentPx }} >
            {message}
        </div>
    );
}

export default GroupedTableErrorRow;
